declare global {
  interface Set<T> {
    toJSON():  any
  }
}

Set.prototype.toJSON = function <T>(this: Set<T>): T[] {
  return [...this]
};

export default {}
